import React from 'react';
import { Outlet } from 'react-router-dom';

import Tab from '../tabs/components/Tab';
import TabMenu from '../tabs/components/TabMenu';

import Map from '../map/components/Map';

import TopBar from './TopBar';
import { Image, Layers, Search, Tool } from 'react-feather';
import DetailsTab from '../tabs/components/DetailsTab';
import Tutorial from '../tutorial/components/Tutorial';



const Layout: React.FC = () => {
  return (
    <div>
      <TopBar />

      <TabMenu>
        <Tab Icon={Layers} url='/legend' label="Legend Tab" />
        <Tab Icon={Image} url="/imagery" label="Imagery Tab"/>
        <Tab Icon={Search} url="/search" label="Search Tab"/>
        <DetailsTab />
        <Tab Icon={Tool} url="/tools" label="Tools Tab"/>
      </TabMenu>
      <Tutorial />
      <Outlet />

      <Map />
    </div>
  )
}

export default Layout;